import { render } from "./BattleHeader.vue?vue&type=template&id=67bcebb2&scoped=true"
import script from "./BattleHeader.vue?vue&type=script&lang=js"
export * from "./BattleHeader.vue?vue&type=script&lang=js"

import "./BattleHeader.vue?vue&type=style&index=0&id=67bcebb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bcebb2"]])

export default __exports__